import s from "../clinic.module.css";
import { Button, Input } from "../../ui";

export default function VenueStepForm({
  branches,
  draft,
  addressDraft,
  onDraftChange,
  onAddressDraftChange,
  onAdd,
  onRemove,
  onContinue,
  saving,
  adding,
  submitLabel = "Продолжить",
}) {
  const canAdd = Boolean(draft.trim() && addressDraft.trim());
  const canContinue = branches.length > 0;

  const handleAddKeyDown = (e) => {
    if (e.key === "Enter" && canAdd) {
      e.preventDefault();
      onAdd();
    }
  };

  return (
    <form
      onSubmit={(e) => {
        e.preventDefault();
        if (canContinue) onContinue(e);
      }}
      className={[s.onboardingForm, s.onboardingVenueForm].join(" ")}
    >
      <div className={s.onboardingVenueFields}>
        <Input
          value={draft}
          onChange={(e) => onDraftChange(e.target.value)}
          onKeyDown={handleAddKeyDown}
          placeholder="Название зала"
          className={s.onboardingVenueInput}
          autoFocus
        />
        <Input
          value={addressDraft}
          onChange={(e) => onAddressDraftChange(e.target.value)}
          onKeyDown={handleAddKeyDown}
          placeholder="Адрес"
          className={s.onboardingVenueInput}
        />
        <Button
          type="button"
          className={s.onboardingVenueAddBtn}
          disabled={!canAdd || adding}
          onClick={onAdd}
        >
          {adding ? "…" : "Добавить"}
        </Button>
      </div>

      <section className={s.onboardingVenueListBlock} aria-live="polite">
        <h4 className={s.onboardingVenueListTitle}>Уже есть:</h4>
        {branches.length === 0 ? (
          <p className={s.onboardingVenueListEmpty}>Пока нет залов</p>
        ) : (
          <ul className={s.onboardingVenueList}>
            {branches.map((branch) => (
              <li key={branch.id} className={s.onboardingVenueCard}>
                <div className={s.onboardingVenueCardBody}>
                  <span className={s.onboardingVenueCardName}>{branch.name}</span>
                  {branch.address ? (
                    <span className={s.onboardingVenueCardAddress}>
                      {branch.address}
                    </span>
                  ) : null}
                </div>
                <button
                  type="button"
                  className={s.onboardingVenueCardRemove}
                  onClick={() => onRemove(branch.id)}
                  aria-label={`Удалить ${branch.name}`}
                >
                  ×
                </button>
              </li>
            ))}
          </ul>
        )}
      </section>

      <div className={s.onboardingSheetFoot}>
        <Button
          type="submit"
          disabled={!canContinue || saving}
          className={s.onboardingSubmitBtn}
          block
        >
          {saving ? "Сохранение…" : submitLabel}
        </Button>
      </div>
    </form>
  );
}
